import { Formik, Form } from 'formik';
import { initialValues, validationSchema_18715 } from 'blocks/Form/data/validation';
import FirstName from 'blocks/Form/fields/FirstName';
import LastName from 'blocks/Form/fields/LastName';
import Email from 'blocks/Form/fields/Email';
import Hospital from 'blocks/Form/fields/Hospital';
import MarketingRequested from 'blocks/Form/fields/MarketingRequested';
import Submit from 'blocks/Form/fields/Submit';
import LicenseNumber from 'blocks/Form/fields/LicenseNumber';
import UsStates from 'blocks/Form/fields/UsStates';

/* === THV - Structural Heart === */

const Form18715 = ({ handleSubmit, isPending, language, fields }) => {
	const {
		first_name,
		last_name,
		hospital,
		email_address,
		marketing_requested,
		license_number,
		us_states,
		submit,
		validation,
	} = fields;

	initialValues.Country = 'United States';
	return (
		<Formik
			initialValues={initialValues}
			onSubmit={values => handleSubmit('marketo', values)}
			validationSchema={validationSchema_18715(validation)}
		>
			{formik => (
				<Form className='form form--lg'>
					<div className='grid-lg-2 row-gap-0'>
						<FirstName label={first_name} initialValues={initialValues} />
						<LastName label={last_name} initialValues={initialValues} />
						<Email label={email_address} initialValues={initialValues} />
						<Hospital label={hospital} initialValues={initialValues} />
						<LicenseNumber label={license_number} initialValues={initialValues} formik={formik} />
						<UsStates initialValues={initialValues} data={us_states} />
					</div>
					<MarketingRequested
						formik={formik}
						initialValues={initialValues}
						data={marketing_requested}
					/>
					<Submit
						formik={formik}
						isPending={isPending}
						pendingText={submit.submitting}
						validation={submit.all_required_fields}
					>
						{submit.contact_now}
					</Submit>
				</Form>
			)}
		</Formik>
	);
};

export default Form18715;
